import { Icon } from '../icons/Icon.js';

export function VideoGen() {
  return (
    <div className="placeholder">
      <div className="placeholder-icon"><Icon name="video" size={28} /></div>
      <h2 className="placeholder-title">视频生成 · 开发中</h2>
      <p className="placeholder-sub">
        「创作」模块开发中。当前优先打磨「替换」三件套，敬请期待。
      </p>
    </div>
  );
}
